<div class="jumbotron text-center">
  <div class="container">
    <div class="row">
      <div class="col-sm-12" style="text-align:left">
        <button type="button" class="btn btn-outline-primary" (click)="open(content)">Create New User</button>
      </div>
    </div>
    <br>
      <div class="row">
        <div class="col-sm-12 table-responsive">
          <div class="users-table-wrap">
            <table class="table table-bordered table-hover align-middle users-table">
              <thead>
                <tr class="table-secondary">
                  <th>#</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>User Type</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @if (list_length == 0) {
                  <tr class="empty-row">
                    <td colspan="6">No data found</td>
                  </tr>
                }
                @for (user of users | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track user.id; let i = $index) {
                  <tr>
                    <td>{{ ((page-1) * pageSize) + (i+1) }}</td>
                    <td>
                      @if (user.role=='admin') {
                        <span>{{user.username}}</span>
                      }
                      @if (user.role!='admin') {
                        <a class="user-link" href="#" [routerLink]="['/employees']" [queryParams]="{ id: user.id }">{{user.username}}</a>
                      }
                    </td>
                    <td>{{user.email}}</td>
                    <td>{{ user.phone && user.phone != 0 ? user.phone : '' }}</td>
                    <td>
                      <span class="badge" [ngClass]="roleBadge(user.role)">{{ user.role | titlecase }}</span>
                    </td>
                    <td class="actions-cell">
                      @if (utility.isAdmin()) {
                        <div class="btn-group btn-group-sm" role="group" aria-label="User actions">
                          <button disabled type="button" class="btn btn-danger" title="Delete"
                          (click)="onDelete(user.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                              <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                          </button>
                          <button type="button" class="btn btn-secondary" title="Change password"
                          (click)="changeP(content3, user.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-key" viewBox="0 0 16 16">
                              <path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.792-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5"/>
                              <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                          </button>
                          <button type="button" class="btn btn-info" title="Edit"
                          (click)="edit(content2, user.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                              <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                            </svg>
                          </button>
                          @if (user.is_active == 0) {
                            <button type="button" class="btn btn-success" title="Enable"
                            (click)="onEnable(user.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-unlock" viewBox="0 0 16 16">
                                <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z"/>
                              </svg>
                            </button>
                          }
                          @if (user.is_active == 1) {
                            <button type="button" class="btn btn-warning" title="Disable"
                            (click)="onDisable(user.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock" viewBox="0 0 16 16">
                                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
                              </svg>
                            </button>
                          }
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pagination-footer">
          <ngb-pagination
            class="mb-0"
            [collectionSize]="users.length"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="5"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">New User</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input type="text" class="form-control" [(ngModel)]="user.email" id="email" placeholder="add email">
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input type="password" class="form-control" [(ngModel)]="user.password" id="password"
          placeholder="add password">
      </div>
      <div class="mb-3">
        <label class="form-label" for="username">Username</label>
        <input type="text" class="form-control" [(ngModel)]="user.username" id="username"
          placeholder="add name in english">
      </div>
      <div class="mb-3">
        <label class="form-label" for="phone">Mobile</label>
        <input type="number" class="form-control" [(ngModel)]="user.phone" id="phone"
          placeholder="add mobile number">
      </div>
      <div class="mb-3">
        <label class="form-label" for="status">Role</label>
        <select class="form-select" [(ngModel)]="user.role_id">
          @for (role of roles; track role) {
            <option [ngValue]='role.id'>{{ role.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnSubmit(employeeContent)">Add</button>
    </div>
  </ng-template>

  <ng-template #content2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Edit User</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label" for="email">email</label>
        <input type="text" class="form-control" [(ngModel)]="new_user.email" id="email">
      </div>
      <div class="mb-3">
        <label class="form-label" for="username">Username</label>
        <input type="text" class="form-control" [(ngModel)]="new_user.username" id="username" disabled>
      </div>
      <div class="mb-3">
        <label class="form-label" for="phone">Mobile</label>
        <input type="number" class="form-control" [(ngModel)]="new_user.phone" id="phone">
      </div>
      <div class="mb-3">
        <label class="form-label" for="status">Role</label>
        <select class="form-select" [(ngModel)]="new_user.role_id">
          @for (role of roles; track role) {
            <option [ngValue]='role.id'>{{ role.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(new_user_id)">Edit</button>
    </div>
  </ng-template>
  <ng-template #content3 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Reset Password</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label" for="email">email</label>
        <input type="text" class="form-control" [(ngModel)]="user_password.email" id="email" disabled>
      </div>
      <div class="mb-3">
        <label class="form-label" for="password">New Password</label>
        <input type="password" class="form-control" [(ngModel)]="user_password.password" id="password"
          placeholder="add password">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnChangePassword(user_password.id)">OK</button>
    </div>
  </ng-template>

  <ng-template #employeeContent let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Employee Details</h4>

      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input type="text" class="form-control" [(ngModel)]="employee.name" id="name" placeholder="Full Name">
      </div>
      <div class="mb-3">
        <label for="id_number" class="form-label">Id Number</label>
        <input type="text" class="form-control" [(ngModel)]="employee.id_number" id="id_number"
          placeholder="123456789">
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="country" class="form-label">Country</label>
            <input type="text" class="form-control" [(ngModel)]="employee.country" id="country"
              placeholder="Employee Nationality">
          </div>
          <div class="col">
            <label for="gender" class="form-label">Gender</label>
            <select class="form-select" [(ngModel)]="employee.gender" id="gender">
              <option value="0">--- Select ---</option>
              <option value='male'>Male</option>
              <option value='female'>Female</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="basic_salary" class="form-label">Basic Salary</label>
        <input type="number" class="form-control" [(ngModel)]="employee.basic_salary" id="basic_salary">
      </div>
      <div class="mb-3">
        <label for="bank_name" class="form-label">Bank Name</label>
        <input type="text" class="form-control" [(ngModel)]="employee.bank_name" id="bank_name"
          placeholder="Bank Name">
      </div>
      <div class="mb-3">
        <label for="account_number" class="form-label">Bank Account No.</label>
        <input type="number" class="form-control" [(ngModel)]="employee.account_number" id="account_number"
          placeholder="023456789123451">
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="birth_date" class="form-label">Date of Birth</label>
            <input type="date" class="form-control" [(ngModel)]="employee.birth_date" id="birth_date">
          </div>
          <div class="col">
            <label for="id_expiry_date" class="form-label">Id Expiry Date</label>
            <input type="date" class="form-control" [(ngModel)]="employee.id_expiry_date" id="id_expiry_date">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnAddDetails()" [disabled]="employee.name==null">Save</button>
    </div>
  </ng-template>